const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTIONS)

export const apiPromotions = {
	fetchDiscounts: async (
		status: EPromotionStatus[] | undefined,
		type: EPromotionType[] | undefined,
		search: string | undefined,
		page: number = 1,
		perPage: number = 25,
		isInfluencer: boolean = false,
	): Promise<IApiResponseModel<IDiscountCouponListItemModel[]>> => {
		const isActive = status?.includes(EPromotionStatus.ACTIVE)
		const isInactive = status?.includes(EPromotionStatus.INACTIVE)
		let activeFilter: string[] | undefined
		if (isActive && isInactive) activeFilter = ['true', 'false']
		else if (isActive) activeFilter = ['true']
		else if (isInactive) activeFilter = ['false']
		const { data, meta } = await apiCommon<IDiscountCouponListItem[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(
				{ page, perPage },
				{ search, is_active: activeFilter, action_type: type, is_influencer: isInfluencer },
				{ id: EApiSortType.DESC },
			),
		})
		return { data: data.map(CouponListItem), meta }
	},
	/**
	 * After changes at the backend we fetch promotion as a coupon with promotion details
	 */
	fetchDiscountPromotionDetails: async (couponId: number): Promise<IDiscountCouponModel> => {
		const { data } = await apiCommon<IDiscountCoupon>(`${groupPrefix}/${couponId}`, {
			method: 'GET',
		})

		return Coupon(data)
	},
	createDiscountPromotion: async (payload: any): Promise<IDiscountPromotionModel> => {
		const { data } = await apiCommon<IDiscountPromotion>(`${groupPrefix}`, { method: 'POST', body: payload })

		return DiscountPromotion(data)
	},
	updateDiscountWithPayload: async (
		id: number,
		payload: IPromotionUpdatePayload,
	): Promise<IDiscountCouponListItemModel> => {
		const { data } = await apiCommon<IDiscountCouponListItem>(`${groupPrefix}/${id}`, {
			method: 'PUT',
			body: payload,
		})

		return CouponListItem(data)
	},
	updatePromotionBulk: async (promotionIDs: number[], isActive: boolean) => {
		const { data } = await apiCommon<IDiscountPromotion>(`${groupPrefix}/update-many`, {
			method: 'PUT',
			body: { ids: promotionIDs, is_active: isActive },
		})
		return DiscountPromotion(data)
	},
	deletePromotion: async (promotionID: number): Promise<void> => {
		await apiCommon<IDiscountPromotion>(`${groupPrefix}/${promotionID}`, { method: 'DELETE' })
	},
	deletePromotionBulk: async (promotionIDs: number[]) =>
		await apiCommon<IDiscountPromotion>(`${groupPrefix}/destroy-many`, {
			method: 'DELETE',
			body: { ids: promotionIDs },
		}),
	fetchPromotionHistory: async (
		couponId: number,
		page: number = 1,
		perPage: number = 25,
	): Promise<IApiResponseModel<IDiscountPromotionHistoryModel[]>> => {
		const { data, meta } = await apiCommon<IDiscountPromotionHistory[]>(`${groupPrefix}/${couponId}/accesses`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})

		return { data: data.map(PromotionHistory), meta }
	},
}
